export default __webpack_public_path__ + "static/media/sutcliffe-crop.aa4eb3a9.jpg";